import styled from 'styled-components';

export default styled.div`
	display: flex;
	gap: var(--spacing-large);
	justify-content: space-between;

	.comp-header {
		color: var(--neutrals-700);
	}
`;
